const path = `m 240.99497,196.71742
c 3.3641,-4.54136 9.75964,-16.10609 9.75964,-16.10609 0,0 3.23566,-6.29846 4.78468,-9.9689 1.65733,-3.92708 6.53852,-14.86953 10.46281,-21.81551 6.88269,-12.18233 20.14793,-31.85621 23.91884,-37.61182 3.77091,-5.7556 14.21732,-14.827059 14.21732,-14.827059 5.97818,-4.040636 -0.33479,-15.328661 -9.13016,-4.563859 -7.14762,8.748088 -24.11875,32.463048 -28.21927,40.313248 -6.69689,12.82079 -13.89701,31.61609 -16.30741,36.2376 -6.35589,12.18629 -7.69127,14.76497 -19.58592,28.13899 -16.55631,18.61546 -26.92927,38.47727 -31.66581,51.12535 -6.69975,17.89049 -11.50031,38.22576 -17.5227,57.33031 -6.47927,20.5539 -1.54955,41.05092 -15.9589,70.01255 -4.35241,8.74799 -8.35708,17.72597 -15.60114,22.69024 -11.09777,7.60517 -17.96642,9.27838 -29.26176,16.47489 -9.88519,6.29808 -20.68074,17.12551 -26.375945,25.61421 -5.498482,8.19547 -7.334722,12.13129 -10.235602,22.52662 -4.293943,15.38738 -7.321215,28.27744 -5.463362,43.59975 1.754805,14.47245 6.870421,26.72155 10.885803,39.01658 4.221121,12.925 2.753184,20.37629 -3.773449,32.30426 -5.648383,10.3229 -8.549254,12.70998 -15.647919,22.09483 -4.411668,5.83249 -6.967115,10.62885 -21.413381,24.99269 -8.476429,8.42806 -12.195238,18.39298 -12.093113,27.52874 0.185751,16.61657 3.564187,36.19228 4.015713,50.74696 0.36688,11.8262 -0.760188,9.26605 -1.934011,21.03956 -1.342696,13.46731 0.08975,31.62085 -2.294647,44.94323 -2.481687,13.86599 -3.037522,25.10311 -0.846801,36.38235 0.800299,4.12045 2.452852,15.34778 10.70245,24.74795 39.800881,46.73796 54.677664,63.04296 75.588324,107.93943 2.01853,4.33393 10.83126,3.5438 6.49548,-3.7038
C 108.25838,900.09406 95.826547,876.45429 48.995489,825.47238 31.870676,806.82971 40.1625,774.3019 40.1625,774.3019
c 0,0 3.779001,-26.65456 3.779001,-30.55863 0,-3.90407 2.719849,-33.37777 2.883828,-35.77268 0.292534,-4.27245 1.560868,-16.38766 -0.994977,-31.20906 -1.677508,-9.7279 -2.150472,-21.58001 -2.285649,-24.87304 -0.269059,-6.55451 2.911035,-16.46191 7.158075,-22.84119 5.124443,-7.69718 10.816524,-12.07877 19.650785,-20.17537 2.686792,-2.46245 15.579365,-17.17071 19.299128,-23.5481 2.942739,-5.04521 6.925755,-15.22873 8.196096,-23.22174 0.832692,-5.23932 0.211195,-12.67509 -6.635462,-33.43372 -7.334308,-22.23717 -5.950662,-25.16242 -6.740475,-33.63647 -0.830601,-8.91168 0.926816,-22.34452 5.206077,-33.54582 3.10878,-8.13747 7.371254,-16.47742 10.905253,-21.48166 1.6617,-2.35302 6.20237,-9.53931 12.55681,-13.82368 5.5652,-3.75224 25.16753,-13.86682 32.94931,-18.78334 8.21172,-5.18815 21.8288,-19.52429 23.95912,-23.44188 2.79037,-5.13142 11.52087,-20.76955 13.64158,-30.6431 1.81355,-8.44347 3.14586,-17.31702 5.18385,-29.16376 1.9397,-11.27536 6.98008,-43.58282 11.24699,-57.07988 2.47494,-7.82871 10.06755,-24.27042 13.29938,-31.00131 1.32452,-2.75856 4.4228,-12.40837 12.90991,-22.5929 3.91951,-4.70343 11.29973,-12.21578 14.66384,-16.75715
z`;
const pathUmberto = `m 233.55762,193.61397
c 4.66915,-6.64514 7.85948,-18.97108 12.03294,-27.12948 3.25586,-6.36466 17.62066,-28.1914 20.1179,-32.23711`;

const pathIsabella = `m 186.46301,338.29562
c -3.80896,19.66006 -7.14518,35.61062 -13.73154,47.19876 -2.97661,5.23708 -15.2968,15.07946 -30.98922,24.59249`;

const pathBalbi = `m 78.085223,493.04448
c 1.330995,-46.84685 4.068612,-58.27931 42.799967,-78.89712`;

const dangerMoncaliere = `m 150.8013,1046.7977
c 0,0 6.4198,4.826 12.84689,1.5238 -4.62,4.4684 -10.73252,10.2464 -12.67175,12.3783 -2.57938,2.8357 -4.54486,4.9866 -9.51755,10.254 -5.19776,5.5057 -15.00311,13.0564 -19.50549,17.8067 -4.22701,4.4597 -15.79642,15.0393 -21.63169,23.4125 -3.706548,-3.829 -6.243911,-6.5816 -10.963061,-12.1612 0,0 24.609971,-17.3681 29.536811,-22.9918 1.67293,-1.9095 8.59064,-7.3434 11.524,-10.8502 2.30439,-2.7549 13.71853,-12.4814 20.38184,-19.3721
z`;

const dangerMurazzi = `m 299.19159,80.191311 c 0,0 10.5997,2.66502 13.39196,14.214781 5.71142,-3.807613 10.08864,-6.47417 10.08864,-6.47417 L 306.01057,72.551191 Z`;

const dangerSangone = `m 35.581566,819.44163 -2.153621,0.0936 -0.561814,15.91807 -4.11997,-0.37454 2.153621,-16.47989 1.966349,-11.51718
c 0,0 0.09364,5.61813 2.715435,12.3599
z`;

const biggestRoute = `m 304.88712,87.773043
c 0,0 -34.44679,39.580677 -53.49187,80.817447 -19.0451,41.23677 -26.22604,39.11177 -39.24946,60.28186 -22.35151,36.33327 -27.46728,122.73659 -43.88652,153.18881 -15.19657,28.18458 -61.70326,32.74354 -77.174038,63.09722 -17.196421,33.7394 -10.467928,61.93178 3.972383,108.36705 8.392295,26.98685 -46.80133,70.91187 -51.999141,84.40241 -6.174269,16.02487 2.515825,53.66036 1.159266,69.556 -0.828818,9.71177 -4.721511,63.56233 -7.163246,76.92201 -2.726399,14.91719 1.149492,31.90085 10.144217,42.81367 5.11923,6.21089 38.752628,46.37069 46.039446,54.81677 7.286823,8.44608 26.920163,39.91195 34.920193,56.47282 8.00003,16.56087 9.43245,20.48434 14.77929,29.3825 5.34684,8.89816 14.53544,17.15139 16.66848,26.60814 1.04824,4.64734 2.98278,37.16195 -1.22351,50.75015`;

export function SVGPaths() {
  return (
    <>
      <path d={path} stroke="#4dbe6dff" strokeWidth="2.5" fill="none" />
      <path
        d={pathUmberto}
        stroke="#4dbe6dff"
        strokeWidth="2"
        opacity={0.5}
        fill="none"
      />
      <path
        d={pathIsabella}
        stroke="#4dbe6dff"
        strokeWidth="2"
        opacity={0.5}
        fill="none"
      />
      <path
        d={pathBalbi}
        stroke="#4dbe6dff"
        strokeWidth="2"
        opacity={0.5}
        fill="none"
      />
      <path
        d={dangerMoncaliere}
        stroke="none"
        fill="url(#pattern3)"
        opacity={0.1}
      />
      <path
        d={dangerMurazzi}
        stroke="none"
        fill="url(#pattern3)"
        opacity={0.1}
      />
      <path
        d={dangerSangone}
        stroke="none"
        fill="url(#pattern3)"
        opacity={0.1}
      />
      <path
        d={biggestRoute}
        id="distance"
        stroke="transparent"
        strokeWidth="0"
        fill="none"
      />
      <circle
        id="target"
        cx="10"
        cy="10"
        stroke="rgba(0, 0, 0, .25)"
        strokeWidth="1"
        r="1.5"
        fill="white"
      />
    </>
  );
}
